import { render, staticRenderFns } from "./StreamOwnerBatchItems.vue?vue&type=template&id=1684fccd&"
import script from "./StreamOwnerBatchItems.vue?vue&type=script&lang=ts&"
export * from "./StreamOwnerBatchItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports